import { wrap } from 'svelte-spa-router/wrap'
import Auth from './auth'

import Informations from './$views/informations.view.svelte'
import Login from './$views/login.view.svelte'
import NotFound from './$views/notfound.view.svelte'
import Pickups from './$views/pickups.view.svelte'
import Requests from './$views/requests.view.svelte'
import Settings from './$views/settings.view.svelte'
import Shipment from './$views/shipments.view.svelte'
import Signup from './$views/signup.view.svelte'
import Tickets from './$views/tickets.view.svelte'
import Welcome from './$views/welcome.view.svelte'
import Tracking from './$views/tracking.view.svelte'
import TrackingGuide from './$views/tracking.guide.view.svelte'
import Quotation from './$views/quotation.view.svelte'

const routes = {

    '/': wrap({
        component: Login,
        conditions: [Auth.needLogin]
    }),

    '/login': wrap({
        component: Login,
        conditions: [Auth.needLogin]
    }),

    '/signup': wrap({
        component: Signup,
        conditions: [Auth.needLogin]
    }),

    '/welcome': wrap({
        component: Welcome,
        conditions: [Auth.needLogin]
    }),

    '/quotations': wrap({
        component: Requests,
        conditions: [Auth.isLogin]
    }),

    '/pickups': wrap({
        component: Pickups,
        conditions: [Auth.isLogin]
    }),

    '/shipments': wrap({
        component: Shipment,
        conditions: [Auth.isLogin]
    }),

    '/tickets': wrap({
        component: Tickets,
        conditions: [Auth.isLogin]
    }),

    '/informations/:tab?': wrap({
        component: Informations,
        conditions: [Auth.isLogin]
    }),

    '/settings/:tab?': wrap({
        component: Settings,
        conditions: [Auth.isLogin]
    }),

    '/tracking/:shipmentId': wrap({
        component: Tracking
    }),

    '/tracking': wrap({
        component: TrackingGuide
    }),

    '/quotation': wrap({
        component: Quotation
    }),

    '*': wrap({
        component: NotFound
    })
}

export { routes }